import React, { useEffect, useState } from "react";

import { Navigate, useParams } from "react-router-dom";
import { Box, Button, CircularProgress, CssBaseline, Link, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import MetaDecorator from "../services/meta_decorator";
import NDReferralHeader from "../components/shared/ndreferralheader";
import { getApiUrl } from "../services/api_service";
import { ValidateReferralOTP } from "./referrerlogin";
import { blackcolor, bodyBg, footerContainer, fullHeight, pcolor, rcolor, whitecolor } from "../style2";
import Footer from "../components/shared/footer";

export default function ReferrerRegister() {
    const { orgCode } = useParams();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [organizationName, setOrganizationName] = useState('');
    const [title, setTitle] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState('');
    const [error, setError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [success, setSuccess] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [redirect, setRedirect] = useState('');
    const [showValidateOTP, setShowValidateOTP] = useState(false);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                setRedirect(`/screenprocess/${orgCode}`);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        });
    }, [])

    const registerFunc = () => {
        setError('');
        setSuccess('');
        setPhoneError('');
        setEmailError('');
        if(email.trim() === ''){
            setEmailError('Email is required.');
            return;
        }else if(email.indexOf('+') !== -1){
            setEmailError('Email cannot contain + character.');
            return;
        }else if(email.indexOf(' ') !== -1){
            setEmailError('Email cannot contain space character.');
            return;
        }
        // Validate phone number: if starts with 0, must be 11 digits; else, must be 10 digits
        let valid = false;
        if (phone.startsWith('0')) {
            valid = /^0\d{10}$/.test(phone);
        } else {
            valid = /^\d{10}$/.test(phone);
        }
        if (!valid) {
            setPhoneError('Incomplete mobile number. Enter 11 digits if starting with 0, or 10 digits if not.');
            setLoading(false);
            return;
        }
        setLoading(true);
        fetch(`${getApiUrl()}/ReferrerAccount/register`, {
            method: 'POST',
            body: JSON.stringify({
                name, email, title, organization: organizationName, phone
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status === 200) {
                setSuccess(`Congratulations! You have successfully registered with the email address: <strong>${email}</strong>.<br/><br/>An OTP (One-Time Passcode) has been sent to your email. Please check your inbox and enter the OTP to complete your registration.`);
                setShowSuccessModal(true);
            }
            else if (response.status === 404) {
                setError("Please register to refer a child.")
            }
            else {
                response.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err => {
                    console.log(err);
                    setError("Unable to process request.");
                })
            }
        }).catch(err => {
            console.log(err);
            setError("Unable to contact server.");
        }).finally(() => {
            setLoading(false);
        })
    }

    if (redirect !== "")
        return <Navigate to={redirect} replace />
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader  orgCode={orgCode} logo="../../logo.jpg" />

            {/* Success Modal Popup */}
            <Dialog
                open={showSuccessModal}
                onClose={() => { }}
                disableEscapeKeyDown
                aria-labelledby="success-dialog-title"
                aria-describedby="success-dialog-description"
                PaperProps={{ style: { pointerEvents: 'auto' } }}
                BackdropProps={{ style: { pointerEvents: 'auto' } }}
            >
                <DialogTitle id="success-dialog-title">Registration Successful</DialogTitle>
                <DialogContent>
                    <Typography id="success-dialog-description" style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: success }}></Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setShowSuccessModal(false);
                            setShowValidateOTP(true);
                        }}
                        autoFocus
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {showValidateOTP ?
                <Box sx={{ maxWidth: "800px", padding: "5rem 10rem", margin: "0 auto" }}>
                    <ValidateReferralOTP email={email} redirect={`/patients/${orgCode}`} /> </Box> :
                <Box sx={{ width: "60%", padding: "5rem 10rem", margin: "0 auto" }}>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        registerFunc();
                    }}>
                        <Typography component="h1" sx={{color: pcolor, fontSize: "2rem", fontWeight: "bold", marginBottom: "0.3rem"}}>Create an Account</Typography>
                        <Typography component="p" sx={{color: pcolor, fontSize: "0.9rem", marginBottom: "2rem"}}>Set up your EnrichMyCare account to get started.</Typography>   
                        <Box mb={3}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>
                                School / SENCO’S Email *</label>
                            <TextField slotProps={{ input: { maxLength: "150", type: "email" } }}
                            style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "100%" }} 
                            error={!!emailError}
                                helperText={emailError}
                            variant="outlined" required={true} label="" value={email} onChange={(e) => {
                                setEmail(e.target.value);
                                if(email.indexOf('+') !== -1){
                                    setEmailError('Email cannot contain + character.');
                                }else if(email.indexOf(' ') !== -1){
                                    setEmailError('Email cannot contain space character.');
                                } else {
                                    setEmailError('');
                                }
                            }} onBlur={(e) => {
                                
                                if(email.indexOf('+') !== -1){
                                    setEmailError('Email cannot contain + character.');
                                }else if(email.indexOf(' ') !== -1){
                                    setEmailError('Email cannot contain space character.');
                                } else {
                                    setEmailError('');
                                }
                            }} />
                            <Typography component="div" sx={{color: pcolor, fontSize: "0.9rem", mt:1}}>You will receive the OTP on this email address.</Typography>
                        </Box>
                        <Box mb={3}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Mobile Number *</label>
                            <TextField
                                inputProps={{
                                    maxLength: 11
                                }}
                                style={{
                                    border: `1px solid ${pcolor}`,
                                    borderRadius: 5,
                                    width: "100%"
                                }}
                                variant="outlined"
                                label=""
                                value={phone}
                                required={true}
                                error={!!phoneError}
                                helperText={phoneError}
                                placeholder="0xxxxxxxxxx"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Only allow up to 11 digits
                                    if (/^\d{0,11}$/.test(value)) {
                                        setPhone(value);
                                        // Live validation: clear error if valid
                                        if ((value.startsWith('0') && value.length === 11) || (!value.startsWith('0') && value.length === 10)) {
                                            setPhoneError("");
                                        }
                                    }
                                }}
                            />
                            <Typography component="div" sx={{color: pcolor, fontSize: "0.9rem", my:1}}>If you provide a mobile number, you will receive the OTP on this mobile number as well.<br/> 
                            E.g. 07654321098</Typography>
                        </Box>
                        <Box mb={3}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>First and Last Name *</label>
                            <TextField slotProps={{ input: { maxLength: "50" } }} style={{
                                border: `1px solid ${pcolor}`, borderRadius: 5,
                                width: "100%"
                            }} variant="outlined" required={true} label="" value={name} onChange={(e) => {
                                setName(e.target.value);
                            }} />
                        </Box>
                        <Box mb={3}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Job Title</label>
                            <TextField slotProps={{ input: { maxLength: "50" } }} style={{
                                border: `1px solid ${pcolor}`, borderRadius: 5,
                                width: "100%"
                            }} variant="outlined" label="" value={title} onChange={(e) => {
                                setTitle(e.target.value);
                            }} />
                        </Box>
                        <Box mb={3}>
                            <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Organisation Name (Nursery / School)</label>
                            <TextField slotProps={{ input: { maxLength: "190" } }} style={{
                                border: `1px solid ${pcolor}`, borderRadius: 5,
                                width: "100%"
                            }} variant="outlined" label="" required value={organizationName} onChange={(e) => {
                                setOrganizationName(e.target.value);
                            }} />
                        </Box>
                        
                        <Box py={3} textAlign="center">
                            <button type="submit" disabled={loading}
                                style={{
                                    border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.5rem",
                                    height: "50px", width: "444px", borderRadius: 2
                                }}>{loading ? <CircularProgress size={20} /> : null} Register</button>
                        </Box>
                        {error !== "" ? <Box mt={1} mb={2} style={{ color: rcolor, fontSize: "1.1rem", textAlign: "center" }}>{error}</Box> : null}
                    </form>
                    <Box sx={{ textAlign: "center", fontSize: "1.20rem", margin: "15px 0px" }}>
                        <Button type="button" style={{
                            padding: "5px",
                            textTransform: 'none',
                            color: pcolor,
                            fontSize: "1.2rem",
                            '&:hover': {
                                textDecoration: 'underline',
                                backgroundColor: 'transparent',
                            },
                        }}
                            onClick={() => { setRedirect(`/login/${orgCode}`) }}><Typography style={{ marginRight: "10px", color: blackcolor, fontSize: "1.2rem" }}>Already registered?</Typography> <Typography sx={{textDecoration:'underline', fontSize: "1.2rem"}}>Sign in</Typography></Button>

                    </Box>
                    <Box sx={{ textAlign: "center", fontSize: "1.20rem", margin: "15px 0px" }}>
                        Problems registering? <Link href="mailto:contact@enrichmycare.com" target="_blank" rel="noreferrer">Contact Us</Link>
                    </Box>
                </Box>}
            <Box sx={{...footerContainer, position:"static"}}>
                <Footer />
            </Box>
        </Box>;
}